import React, { useEffect, useMemo } from 'react';
import { Flex, Spin } from 'antd';
import { getHomeRedirectTarget } from '../redirect';
export const App = () => {
    const target = useMemo(() => getHomeRedirectTarget(window.location.pathname, window.location.hash, window.location.search), []);
    useEffect(() => {
        window.location.replace(target);
    }, [target]);
    return (React.createElement(Flex, { align: "center", justify: "center", style: { minHeight: '100vh' } },
        React.createElement(Spin, { size: "large" })));
};
